module.exports = __webpack_public_path__ + "static/img/smokeSend.ff54c6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/smokeSend.png
// module id = pER1
// module chunks = 208